import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { setStatusValue } from '../../actions/Project/ProjectListAction';

import { setIsShowFindAllViewList } from '../../actions/transOperationActions';

import {
  setIsShowFindAllViewInput,
  setIsShowFindAllViewReplace,
} from '../../actions/transOperation_find_Actions';

import { showMultipleFindReplace } from '../../actions/findActions';

import {
  showHidePositionList,
  setFindPositionTargetData,
} from '../../actions/find/positionFindAction';
import { Button, Form, Icon, Table } from 'semantic-ui-react';
import CreateItem from './MultipleFindReplace/CreateItem';
import ApiUtils from '../../helper/ApiUtils';

class MultipleFindReplaceView extends Component {
  constructor(props) {
    super(props);

    /**
     * 分為兩種模式 true 多一個新的 , false: 更新原有的
     */
    this.isCreateNewItem = false;
    // 要更新的資料
    this.isUpdateItemIndex = 0;

    this.EditNameIndex = 0;

    this.state = {
      isEditName: false,
      isLoadedData: false,
      checked: false,
      showCreate: false,
      showAdditem: false,
      value: 11,
      errors: {},
      multipleFindReplaceData: [
        {
          Name: 'Super hero squad',
          items: [
            {
              find: '111',
              replaceWith: '222',
            },
          ],
        },
        {
          Name: 'Super hero squad 2',
          items: [
            {
              find: '111',
              replaceWith: '222',
            },
          ],
        },
        {
          Name: 'Super hero squad _0item',
          items: [],
        },
      ],
    };
    this.setFindBlue = this.setFindBlue.bind(this);
    this.closeDialog = this.closeDialog.bind(this);

    this.saveMultipleFindReplaceData =
      this.saveMultipleFindReplaceData.bind(this);
  }

  async closeDialog() {
    this.props.showMultipleFindReplace(false);
  }

  async componentDidMount() {
    if (!this.state.isLoadedData) {
      const { user } = this.props.auth;
      const { email } = user;
      const res = await ApiUtils.post_sql(
        `${ApiUtils.post_GetMultipleReplacement}`,
        {
          fEmail: email,
        }
      );
      console.log('post_GetMultipleReplacement', res);

      await this.setState({ isLoadedData: true });

      //  res.forEach(element => {
      //     element.items = JSON.parse( element.items );
      //   });

      if (res === '') {
        await this.setState({ multipleFindReplaceData: [] });
      } else {
        await this.setState({ multipleFindReplaceData: res });
      }
    }

    await this.setState({ value: this.props.project.statusValue });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  async setFindBlue(result) {
    // this.props.showFindPositionAndAlign(result);
  }

  /**
   * 儲存 fMultipleReplacement
   * @param {*} result 資料
   */
  async saveMultipleFindReplaceData(result) {
    // this.props.showFindPositionAndAlign(result);

    const { user } = this.props.auth;
    const { email } = user;

    const res = await ApiUtils.post_sql(
      `${ApiUtils.post_ChangeMultipleReplacement}`,
      {
        fEmail: email,
        fMultipleReplacement: JSON.stringify(result),
      }
    );
  }

  render() {
    const { data } = this.props.editTable;
    const { multipleFindReplaceData } = this.state;

    return (
      <div
        title='Multiple Find Replace View'
        style={{ width: '450px', height: '490px' }}
        ref={(ref) => (this.positionAligndlg = ref)}
      >
        <div
          style={{ width: '540px', height: '410px', overflow: 'scroll' }}
          ref={(ref) => (this.positionAligndlg = ref)}
        >
          {this.state.showCreate === true ? (
            <CreateItem
              handleReplace={(type, user) => {
                this.props.handleReplace(type, user);
              }}
              items={
                this.isCreateNewItem === true
                  ? []
                  : this.state.multipleFindReplaceData[this.isUpdateItemIndex]
                      .items
              }
              isCreateNewItem={this.isCreateNewItem}
              isUpdateItemIndex={this.isUpdateItemIndex}
              multipleFindReplaceData={this.state.multipleFindReplaceData}
              sendMutilData={() => {
                this.saveMultipleFindReplaceData(multipleFindReplaceData);
                alert('save');
              }}
              setShowCreate={() =>
                this.setState({ showCreate: !this.state.showCreate })
              }
              uploadItem={(newitems) => {
                ////// 編輯的
                // 更新
                var newMultipleFindReplaceData =
                  this.state.multipleFindReplaceData;

                newMultipleFindReplaceData[this.isUpdateItemIndex].items =
                  newitems;

                this.setState({
                  MultipleFindReplaceData: newMultipleFindReplaceData,
                });

                this.saveMultipleFindReplaceData(newMultipleFindReplaceData);

                // 關閉 CreateItem
                this.setState({ showAdditem: false });
                // this.setState({ showCreate: false });
              }}
              // 產生新的一個 多重替換
              addNewMultipleFindReplace={async (newMultipleFindReplaceObj) => {
                var array = [...this.state.multipleFindReplaceData];

                array.push(newMultipleFindReplaceObj);

                await this.setState({
                  multipleFindReplaceData: [
                    ...this.state.multipleFindReplaceData,
                    newMultipleFindReplaceObj,
                  ],
                });

                // 更新
                await this.saveMultipleFindReplaceData(array);

                // 關閉 CreateItem
                this.setState({ showAdditem: false });
                this.setState({ showCreate: false });
              }}
            />
          ) : null}

          {this.state.showCreate === false ? (
            <div>
              <Table celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell colSpan='3' width={2}>
                      Items
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {multipleFindReplaceData.map((object, i) => {
                    return (
                      <Table.Row key={i}>
                        <Table.Cell>
                          <Icon
                            name='edit'
                            color='grey'
                            onClick={() => {
                              this.EditNameIndex = i;
                              this.setState({ isEditName: true });
                            }}
                          />{' '}
                          <a
                            style={{
                              textDecoration: 'underline',
                              color: 'blue',
                            }}
                            onClick={async () => {
                              this.isCreateNewItem = false;
                              this.isUpdateItemIndex = i;
                              await this.setState({ newName: object.Name });
                              await this.setState({ showCreate: true });
                            }}
                          >
                            {object.Name}
                          </a>
                          {this.state.isEditName === true &&
                          this.EditNameIndex === i ? (
                            <Form.Field>
                              <input
                                placeholder='Name'
                                value={this.state.newName}
                                onChange={(e) => {
                                  this.setState({ newName: e.target.value });
                                }}
                              />
                            </Form.Field>
                          ) : null}
                          {this.state.isEditName === true &&
                          this.EditNameIndex === i ? (
                            <Button
                              primary
                              size='mini'
                              onClick={async () => {
                                if (this.state.newName !== '') {
                                  var array = [
                                    ...this.state.multipleFindReplaceData,
                                  ]; // make a separate copy of the array
                                  array[i].Name = this.state.newName;
                                  await this.setState({
                                    multipleFindReplaceData: array,
                                  });

                                  // 更新
                                  await this.saveMultipleFindReplaceData(array);

                                  await this.setState({
                                    isEditName: false,
                                  });
                                  await this.setState({ newName: '' });
                                }
                              }}
                            >
                              Save
                            </Button>
                          ) : null}
                        </Table.Cell>
                        <Table.Cell>{object.items.length}</Table.Cell>
                        <Table.Cell>
                          <Button
                            primary
                            size='mini'
                            onClick={async () => {
                              var array = [
                                ...this.state.multipleFindReplaceData,
                              ]; // make a separate copy of the array
                              var index = i;
                              if (index !== -1) {
                                array.splice(index, 1);
                                await this.setState({
                                  multipleFindReplaceData: array,
                                });

                                await this.saveMultipleFindReplaceData(
                                  this.state.multipleFindReplaceData
                                );
                              }
                            }}
                          >
                            Remove
                          </Button>
                        </Table.Cell>
                        <Table.Cell>
                          <Button
                            primary
                            size='mini'
                            onClick={async () => {
                              await this.setState({
                                multipleFindReplaceData: [
                                  ...this.state.multipleFindReplaceData,
                                  multipleFindReplaceData[i],
                                ],
                              });

                              await this.saveMultipleFindReplaceData(
                                this.state.multipleFindReplaceData
                              );
                            }}
                          >
                            Duplicate
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    );
                  })}
                </Table.Body>
              </Table>
            </div>
          ) : null}
        </div>

        {this.state.showCreate === false ? (
          <div>
            <Button
              size='mini'
              content='Standard'
              style={{ width: 80 }}
              onClick={async () => {
                this.isCreateNewItem = true;
                await this.setState({ showCreate: true });
              }}
            >
              Create
            </Button>
          </div>
        ) : null}

        <hr />
        <div className=' '>
          <Button
            size='mini'
            content='Standard'
            style={{ width: 80 }}
            onClick={() => this.props.closeMultipleFindReplaceView()}
          >
            Close
          </Button>
        </div>
      </div>
    );
  }
}

MultipleFindReplaceView.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  setIsShowFindAllViewInput: PropTypes.func.isRequired,
  multipleFind: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
  editTable: state.editTable,
});

export default connect(mapStateToProps, {
  setStatusValue,
  setIsShowFindAllViewInput,
  setIsShowFindAllViewList,
  setIsShowFindAllViewReplace,
  showMultipleFindReplace,
  showHidePositionList,
  setFindPositionTargetData,
})(withRouter(MultipleFindReplaceView));



// WEBPACK FOOTER //
// ./src/components/multipleFind/MultipleFindReplaceView.js